export const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];